import baseAPI from '@/http'

const router = 'api/MunicipiosTemas'

export const municipioTemasApi = {
    listTemaByMunicipio: (municipioId) => baseAPI.get(`${router}/get-municipios-temas-by-id/${municipioId}`),

}
